import { render, staticRenderFns } from "./score-suzhou.vue?vue&type=template&id=a96706ea&scoped=true"
import script from "./score-suzhou.vue?vue&type=script&lang=js"
export * from "./score-suzhou.vue?vue&type=script&lang=js"
import style0 from "./score-suzhou.vue?vue&type=style&index=0&id=a96706ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96706ea",
  null
  
)

export default component.exports